import {ref} from 'vue'
import {useAxiosCreate} from '@/backend/utils.js'
import authHeader from '@/backend/auth/auth-header';

class ApiConnector{

	constructor() {
    	this.api = useAxiosCreate('task');
  	}
	
	post(link,form={}){
		const response = ref()
		const request = async ()=>{
			const res = await this.api.post(link,form,{headers: authHeader()})
			response.value = res.data
		}
		return {response,request}
	}

	get(link,params){
		this.api.get(link,{headers: authHeader()})
	}

	runParser(name){
		const response = ref()
		const request = async ()=>{
			const res = await this.api.put(name,{headers: authHeader()})
			response.value = res.data
		}
		return {response,request}
	}

	runPostParser(name){
		const response = ref()
		const request = async ()=>{
			const res = await this.api.post(name,{headers: authHeader()})
			response.value = res.data
		}
		return {response,request}
	}	

	getStatus(statusCode){
		const response = ref()
		const request = async ()=>{
			const res = await this.api.get('status/'+statusCode,{headers: authHeader()})
			response.value = res.data
		}
		return {response,request}
	}

	updateBlackList(file){
		const formData = new FormData();
    	formData.append('file', file);

		const response = ref()
		const request = async ()=>{
			const res = await this.api.post('clientblacklist',formData,{
				 headers: {
					'Content-Type': 'multipart/form-data',
				},
			})
			response.value = res.data
		}
		return {response,request}
	}


}


export default ApiConnector